import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-numero-final',
  templateUrl: './text-numero-final.component.html',
  styleUrls: ['./text-numero-final.component.scss'],
  viewProviders: [ ParentFormGroup ]
})
export class TextNumeroFinalComponent implements OnInit {

  @Input() formGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
